import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("./views/Home.vue"),
    children: [
      {
        path: "/",
        name: "index",
        component: () => import("./views/index.vue"),
        meta: { showMenu: true }
      },
    
      {
        path: "/parcel",
        name: "parcel",
        component: () => import("./views/parcel.vue"),
        meta: { showMenu: false }
      },
      {
        path: "/newsdetails/:id",
        name: "newsdetails",
        component: () => import("./views/NewsDetails.vue"),
        meta: { showMenu: false }
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;

// Vue.use(Router)
// let kejianrouter = new Router({
// })

// // 判断是否需要登录权限 以及是否登录
// kejianrouter.beforeEach((to, from, next) => {
//   // 判断是否需要登录权限
//   if (to.matched.some(res => res.meta.requireAuth)) {
//     // 判断是否登录
//     if (sessionStorage.getItem('token')) {
//       next()
//     } else {
//       // 没登录则跳转到登录界面
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     next()
//   }
// })

// export default kejianrouter
